import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=650f48f2&scoped=true&"
import script from "./Label.vue?vue&type=script&lang=js&"
export * from "./Label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650f48f2",
  null
  
)

export default component.exports